/**
 * @file
 * Karhu Helsinki theme javascripts
 */

(function ($, Drupal, drupalSettings) {

  "use strict";

  var windowWidth = function(){
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
  }

  /*
  Drupal.behaviors.trestonIndexedVariations = {
    firstShot: false,
    attach: function(context, settings) {
      //Facets
      $('.block-product-version .views .option',context).each(function( i, facets ){
        if( windowWidth() < drupalSettings.breakpoints["treston.large"] ){
          if( !Drupal.behaviors.trestonIndexedVariations.firstShot ){
            $( facets ).toggleClass('open');
            Drupal.behaviors.trestonIndexedVariations.firstShot = true;
          }
          facets.getElementsByTagName('h2')[0].addEventListener('click',function(e){
            $( '.option', e.target.parentElement.parentElement ).removeClass('open');
            $( e.target.parentElement ).toggleClass('open');
          });
        }
      });
    }
  }
  */


  Drupal.behaviors.mobileMegamenu = {
    attach: function(context, settings) {
      var mobileMegamenu = '#block-mobilemenu';
      $(mobileMegamenu + " #mobilemenu-opener").once("Activate megamenu opener").on('click', function(e) {
        var opener = $("#mobilemenu-opener");
        var upperLevel = $(mobileMegamenu + " >UL");
        if(opener.hasClass("expanded")) {
          upperLevel.find(".expanded").each(function(){
            $(this).removeClass("expanded");
          });
          opener.removeClass("expanded");
          upperLevel.removeClass("expanded");
        }
        else {
          opener.addClass("expanded");
          upperLevel.addClass("expanded");
        }

      });

      $(mobileMegamenu + " LI.menuparent >A, " + mobileMegamenu + " LI.menuparent >SPAN").once("Activate megamenu").on('click', function(e) {
        e.preventDefault();
        var clickedLi = $(e.target);
        clickedLi.toggleClass("expanded");
        clickedLi.siblings("UL").toggleClass("expanded");
      });
    }
  }


})(jQuery, Drupal, drupalSettings);
